import React, { useState, useRef, useEffect, useId } from "react"
import { PrismicLink } from "@prismicio/react"
import { Container, Dropdown, Row, Col, Image } from "react-bootstrap"

const LEAVE_DELAY_MS = 80

export default function CustomDropdown({ toggleText, sections }) {
  const [showDropdown, setShowDropdown] = useState(false)
  const leaveTimer = useRef(null)
  const menuId = useId()

  useEffect(() => {
    return () => {
      if (leaveTimer.current) clearTimeout(leaveTimer.current)
    }
  }, [])

  const open = () => {
    if (leaveTimer.current) {
      clearTimeout(leaveTimer.current)
      leaveTimer.current = null
    }
    setShowDropdown(true)
  }

  const scheduleClose = () => {
    if (leaveTimer.current) clearTimeout(leaveTimer.current)
    leaveTimer.current = setTimeout(() => setShowDropdown(false), LEAVE_DELAY_MS)
  }

  const handleToggle = isOpen => setShowDropdown(isOpen)

  const handleKeyDown = event => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault()
      setShowDropdown(prev => !prev)
    } else if (event.key === "Escape" && showDropdown) {
      setShowDropdown(false)
    }
  }

  return (
    <>
      {showDropdown && <div className="nav-dropdown-overlay" aria-hidden="true" />}
      <Dropdown
        className="nav-item position-static"
        bsPrefix="dropdown"
        show={showDropdown}
        onMouseEnter={open}
        onMouseLeave={scheduleClose}
        onFocus={open}
        onBlur={scheduleClose}
        onToggle={handleToggle}
      >
        <Dropdown.Toggle
          as="a"
          role="button"
          tabIndex={0}
          aria-haspopup="true"
          aria-expanded={showDropdown}
          aria-controls={menuId}
          className={`nav-link-st-1 d-block${showDropdown ? " is-open" : ""}`}
          onClick={() => setShowDropdown(prev => !prev)}
          onKeyDown={handleKeyDown}
        >
          {toggleText}
        </Dropdown.Toggle>
        <Dropdown.Menu
          id={menuId}
          className="dropdown-menu-st-1 py-0 pt-lg-0"
          show={showDropdown}
        >
          <Container>
            <Row className="justify-content-lg-center">
              {sections.map((section, sectionIndex) => (
                <Col
                  key={`dropdown-section-${sectionIndex}`}
                  className="py-3 py-lg-4 col-12 col-md-6 col-lg-3 dropdown-col"
                >
                  <div className="dropdown-col-inner">
                    {section.primary.title && (
                      <div className="dropdown-section-header">
                        {section.primary.title}
                      </div>
                    )}
                    {section.primary.subtitle && (
                      <div className="dropdown-subtitle">
                        {section.primary.subtitle}
                      </div>
                    )}
                    {section.items.map((item, itemIndex) => (
                      <React.Fragment key={`dropdown-item-${sectionIndex}-${itemIndex}`}>
                        <PrismicLink
                          field={item.link}
                          className="dropdown-link d-flex align-items-center"
                        >
                          <span className="dropdown-link-icon">
                            <Image
                              width={16}
                              height={16}
                              src={item.icon.url}
                              alt={item.icon.alt}
                            />
                          </span>
                          <span className="dropdown-link-label">{item.label}</span>
                        </PrismicLink>
                        <hr className="divider-st-2" />
                      </React.Fragment>
                    ))}
                  </div>
                </Col>
              ))}
            </Row>
          </Container>
        </Dropdown.Menu>
      </Dropdown>
    </>
  )
}
